import EventEmitter from "base/EventEmitter";

class ImageCropper extends EventEmitter {
    constructor($canvas, url, activeCrop = null, allowCropping = true) {
        super();

        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);

        this.$canvas = $canvas;
        this.canvas = $canvas[0];
        this.$wrap = eotwJSXFactory('div', {class: $canvas.attr("class")}).addClass("admin-cropper");
        this.$buttons = eotwJSXFactory('div', {class: "admin-cropper__buttons"});
        this.allowCropping = allowCropping;
        this.context = this.canvas.getContext("2d");

        if (allowCropping) {
            this.$thumbWrap = eotwJSXFactory('div', {class: "admin-modal__image--thumbnail-wrap"});
            this.$thumbButtons = eotwJSXFactory('div', {class: "admin-cropper__buttons admin-cropper__buttons--small"});
            this.$thumbnail = eotwJSXFactory('canvas', {width: "220", height: "220", class: "admin-cropper__preview"});
            this.thumbnail = this.$thumbnail[0];

            this.$thumbWrap.append(this.$thumbnail);
            this.$thumbWrap.append(this.$thumbButtons);
            this.previewContext = this.thumbnail.getContext("2d");
        }


        this.url = url;

        this.rotation = 0;
        this.activeCrop = activeCrop;
        this.crop = null;
        this.action = null;

        this.img = new Image;
        this.thumbBitmap = this.img;

        this.img.onload = this.initCanvas.bind(this);

        this.img.src = url;

        this.cropping = false;

        this.updateButtons();
    }

    getImageBlob() {
        let dataURI = this.getImageDataUrl();
        // convert base64/URLEncoded data component to raw binary data held in a string
        let byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0) {
            byteString = atob(dataURI.split(',')[1]);
        } else {
            byteString = decodeURI(dataURI.split(',')[1]);
        }

        // separate out the mime component
        let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        let ia = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ia], {type: mimeString});
    }

    getImageDataUrl() {
        let oldCropping = this.cropping;
        this.cropping = false;

        if (this.cropping !== oldCropping) {
            this.render();
        }

        let url = this.canvas.toDataURL("image/png");

        if (this.cropping !== oldCropping) {
            this.cropping = oldCropping;
            this.render();
        }

        return url;
    }

    getThumbDataUrl() {
        this.updatePreview();

        return this.thumbnail.toDataURL();
    }

    updateButtons() {
        if (this.cropping) {
            this.$buttons.html([
                eotwJSXFactory('button', {class: "js-save-crop", type: "button"}, [" Okay"]),
                eotwJSXFactory('button', {class: "js-cancel-crop", type: "button"}, ["Cancel"]),
            ]);
            this.$thumbButtons.hide();
        } else {
            this.$buttons.html([
                eotwJSXFactory('button', {class: "js-rotate", type: "button", 'data-direction': ImageCropper.ROTATE_CLOCKWISE}, [
                    eotwJSXFactory('span', {class: "admin-cropper__icon"}).html("<svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='" + window.CONFIG.adminBuildUrl + "gallery/icons.svg#CW'></use></svg>"),
                    "Rotate CW"
                ]),
                eotwJSXFactory('button', {class: "js-rotate", type: "button", 'data-direction': ImageCropper.ROTATE_COUNTERCLOCKWISE}, [
                    eotwJSXFactory('span', {class: "admin-cropper__icon"}).html("<svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='" + window.CONFIG.adminBuildUrl + "gallery/icons.svg#ACW'></use></svg>"),
                    "Rotate ACW"
                ])
            ]);
            if (this.allowCropping) {
                this.$thumbButtons.show().html(eotwJSXFactory('button', {class: "js-start-crop", type: "button"}, [
                    eotwJSXFactory('span', {class: "admin-cropper__icon"}).html("<svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='" + window.CONFIG.adminBuildUrl + "gallery/icons.svg#edit-icon'></use></svg>"),
                    "Edit Thumb"
                ]))
            }
        }
    }

    rotate(direction = ImageCropper.ROTATE_CLOCKWISE) {
        let width = this.canvas.width;
        let height = this.canvas.height;
        //noinspection JSSuspiciousNameCombination
        this.canvas.width = height;
        //noinspection JSSuspiciousNameCombination
        this.canvas.height = width;

        this.rotation += (Math.PI / 2) * parseInt(direction);
        this.rotation = this.rotation % (2 * Math.PI);

        this.context = this.canvas.getContext("2d");
        this.render();

        this.emit("rotate");

        createImageBitmap(this.canvas).then((bitmap) => {
            this.thumbBitmap = bitmap;
            this.updatePreview();
        })
    }

    updatePreview() {
        if (!this.allowCropping) return;
        let ctx = this.previewContext;

        // ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        // ctx.translate(this.canvas.width / 2, this.canvas.height / 2);
        // ctx.rotate(this.rotation);

        if (this.crop !== null) {
            let crop = this.normaliseCrop(this.crop);

            ctx.drawImage(this.thumbBitmap, crop.x, crop.y, crop.size, crop.size, 0, 0, this.thumbnail.width, this.thumbnail.height);
        }
    }


    initCanvas() {

        this.$canvas.before(this.$wrap);
        this.$wrap.append(this.$canvas);
        this.$wrap.prepend(this.$buttons);

        this.canvas.width = this.img.naturalWidth;
        this.canvas.height = this.img.naturalHeight;

        if (this.activeCrop === null) {
            let size = Math.min(this.canvas.width, this.canvas.height);
            this.activeCrop = {
                x:    (this.canvas.width - size) / 2,
                y:    (this.canvas.height - size) / 2,
                size: size
            };
        }
        this.crop = $.extend({}, this.activeCrop);

        this.bindEvents();
        this.render();
    }

    startCropping() {
        if (!this.allowCropping)return;
        this.cropping = true;
        this.crop = $.extend({}, this.activeCrop);
        this.render();
        this.updateButtons();
        this.emit("cropStart");
    }

    bindEvents() {
        const me = this;
        this.$buttons.on("click", ".js-rotate", function () {
            me.rotate($(this).attr("data-direction"));
            return false;
        }).on("click", ".js-cancel-crop", () => {
            this.cropping = false;
            this.crop = $.extend({}, this.activeCrop);
            this.render();
            this.updateButtons();
            this.emit("cropEnd");
            return false;
        }).on("click", ".js-save-crop", () => {
            this.emit("crop", this.crop);
            this.cropping = false;
            this.activeCrop = this.crop;
            this.render();
            this.updateButtons();
            this.emit("cropEnd");
            return false;
        });
        if (this.allowCropping) {
            this.$thumbButtons.on("click", ".js-start-crop", () => {
                this.startCropping();
                return false;
            })
        }
        this.$canvas.on("mousedown", this.handleMouseDown);
        $(window).on("mousemove", this.handleMouseMove).on("mouseup", this.handleMouseUp);
    }

    handleMouseDown(e) {
        if (!this.cropping) {
            return;
        }
        let canvasPosition = this.getCanvasPosition(e);

        let hoveredElement = this.getHoveredElement(canvasPosition);
        switch (hoveredElement.type) {
            case ImageCropper.ElEMENT_ANCHOR:
                this.action = ImageCropper.ACTION_RESIZE_CROP;

                switch (hoveredElement.item) {
                    case ImageCropper.ANCHOR_TOP_LEFT:
                        this.anchor = ImageCropper.ANCHOR_BOTTOM_RIGHT;
                        break;
                    case ImageCropper.ANCHOR_TOP_RIGHT:
                        this.anchor = ImageCropper.ANCHOR_BOTTOM_LEFT;
                        break;
                    case ImageCropper.ANCHOR_BOTTOM_RIGHT:
                        this.anchor = ImageCropper.ANCHOR_TOP_LEFT;
                        break;
                    case ImageCropper.ANCHOR_BOTTOM_LEFT:
                        this.anchor = ImageCropper.ANCHOR_TOP_RIGHT;
                        break;
                }
                break;
            case ImageCropper.ElEMENT_CONTENT:
                this.action = ImageCropper.ACTION_MOVE_CROP;
                break;
            case ImageCropper.ElEMENT_BACKGROUND:
                this.action = ImageCropper.ACTION_RESIZE_CROP;
                this.anchor = ImageCropper.ANCHOR_TOP_LEFT;
                this.crop = {
                    x:    canvasPosition.x,
                    y:    canvasPosition.y,
                    size: 0
                };
                break;
        }

        this.handleMouseMove(e);
        return false;
    }

    handleMouseUp() {
        this.action = null;
        this.crop = this.normaliseCrop(this.crop);
    }

    getHoveredElement(position) {
        if (this.cropping && this.crop !== null) {
            let scale = this.getScale();
            let item = null;
            [[0, 0], [1, 0], [1, 1], [0, 1]].forEach((sizes, index) => {
                let anchorPosition = {
                    x:    this.crop.x + (this.crop.size * sizes[0]),
                    y:    this.crop.y + (this.crop.size * sizes[1]),
                    size: 10 * scale
                };

                if (anchorPosition.x - anchorPosition.size / 2 < position.x && position.x < anchorPosition.x + anchorPosition.size / 2
                    && anchorPosition.y - anchorPosition.size / 2 < position.y && position.y < anchorPosition.y + anchorPosition.size / 2) {
                    item = {
                        type: ImageCropper.ElEMENT_ANCHOR,
                        item: index
                    };
                }
            });
            if (item !== null) return item;

            if (this.crop.x < position.x && position.x < this.crop.x + this.crop.size
                && this.crop.y < position.y && position.y < this.crop.y + this.crop.size) {
                return {
                    type: ImageCropper.ElEMENT_CONTENT
                };
            }
        }

        return {
            type: ImageCropper.ElEMENT_BACKGROUND
        }
    }

    handleMouseMove(e) {
        if (!this.cropping) {
            this.$canvas.css("cursor", "");
            return;
        }
        let canvasPosition = this.getCanvasPosition(e);
        if (this.action === null) {
            let hoveredElement = this.getHoveredElement(canvasPosition);
            if (hoveredElement === null) {
                return;
            }
            switch (hoveredElement.type) {
                case ImageCropper.ElEMENT_ANCHOR:
                    switch (hoveredElement.item) {
                        case ImageCropper.ANCHOR_TOP_LEFT:
                        case ImageCropper.ANCHOR_BOTTOM_RIGHT:
                            this.$canvas.css("cursor", "nw-resize");
                            break;
                        case ImageCropper.ANCHOR_TOP_RIGHT:
                        case ImageCropper.ANCHOR_BOTTOM_LEFT:
                            this.$canvas.css("cursor", "ne-resize");
                            break;
                    }
                    this.$canvas.css("cursor", "resize-ne");
                    break;
                case ImageCropper.ElEMENT_CONTENT:
                    this.$canvas.css("cursor", "move");
                    break;
                case ImageCropper.ElEMENT_BACKGROUND:
                    this.$canvas.css("cursor", "crosshair");
                    break;
            }
        } else {

            switch (this.action) {
                case ImageCropper.ACTION_RESIZE_CROP:
                    let anchorPoint;
                    switch (this.anchor) {
                        case ImageCropper.ANCHOR_TOP_LEFT:
                            anchorPoint = {x: this.crop.x, y: this.crop.y};
                            break;
                        case ImageCropper.ANCHOR_TOP_RIGHT:
                            anchorPoint = {x: this.crop.x + this.crop.size, y: this.crop.y};
                            break;
                        case ImageCropper.ANCHOR_BOTTOM_RIGHT:
                            anchorPoint = {x: this.crop.x + this.crop.size, y: this.crop.y + this.crop.size};
                            break;
                        case ImageCropper.ANCHOR_BOTTOM_LEFT:
                            anchorPoint = {x: this.crop.x, y: this.crop.y + this.crop.size};
                            break;
                    }

                    let distanceX = canvasPosition.x - anchorPoint.x;
                    let distanceY = canvasPosition.y - anchorPoint.y;

                    switch (this.anchor) {
                        case ImageCropper.ANCHOR_TOP_RIGHT:
                            distanceX = -distanceX;
                            break;
                        case ImageCropper.ANCHOR_BOTTOM_RIGHT:
                            distanceX = -distanceX;
                            distanceY = -distanceY;
                            break;
                        case ImageCropper.ANCHOR_BOTTOM_LEFT:
                            distanceY = -distanceY;
                            break;
                    }

                    let distance = Math.abs(distanceX) > Math.abs(distanceY) ? distanceX : distanceY;

                    switch (this.anchor) {
                        case ImageCropper.ANCHOR_TOP_LEFT:
                            this.crop.size = distance;
                            break;
                        case ImageCropper.ANCHOR_TOP_RIGHT:
                            this.crop.size = distance;
                            this.crop.x = anchorPoint.x - distance;
                            break;
                        case ImageCropper.ANCHOR_BOTTOM_RIGHT:
                            this.crop.size = distance;
                            this.crop.x = anchorPoint.x - distance;
                            this.crop.y = anchorPoint.y - distance;
                            break;
                        case ImageCropper.ANCHOR_BOTTOM_LEFT:
                            this.crop.size = distance;
                            this.crop.y = anchorPoint.y - distance;
                            break;
                    }
                    this.render();
                    break;
                case ImageCropper.ACTION_MOVE_CROP:
                    this.crop.x = canvasPosition.x - (this.crop.size / 2);
                    this.crop.y = canvasPosition.y - (this.crop.size / 2);
                    this.render();
                    break;
            }
        }
    }

    normaliseCrop(crop) {
        crop = $.extend({}, crop);
        if (crop.size < 0) {
            crop = {
                x:    crop.x + crop.size,
                y:    crop.y + crop.size,
                size: -crop.size,
            };
        }
        crop.size = Math.min(crop.size, Math.min(this.canvas.width, this.canvas.height));
        crop.x = Math.max(0, crop.x);
        crop.y = Math.max(0, crop.y);
        crop.x = Math.min(this.canvas.width - crop.size, crop.x);
        crop.y = Math.min(this.canvas.height - crop.size, crop.y);

        return crop;
    }

    destroy() {
        $(window).off("mousemove", this.handleMouseMove).off("mouseup", this.handleMouseUp);

        this.img = null;
        this.thumbBitmap = null;

        this.$canvas.remove();
        if (this.allowCropping) {
            this.$thumbnail.remove();
        }
    }

    getCanvasPosition(e) {
        let canvasOffset = this.$canvas.offset();
        return {x: Math.round((e.pageX - canvasOffset.left) * this.getScale()), y: Math.round((e.pageY - canvasOffset.top) * this.getScale())};
    }

    getScale() {
        return this.canvas.width / this.$canvas.width();
    }

    render() {
        const ctx = this.context;
        //Reset the rotation
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        ctx.translate(this.canvas.width / 2, this.canvas.height / 2);
        ctx.rotate(this.rotation);

        ctx.drawImage(this.img, -this.img.width / 2, -this.img.height / 2);
        ctx.setTransform(1, 0, 0, 1, 0, 0);

        if (this.cropping && this.crop !== null) {
            let handleSize = 10 * this.getScale();
            let halfHandleSize = handleSize / 2;
            let lineWidth = 2 * this.getScale();
            let crop = this.normaliseCrop(this.crop);


            //Draw dark background
            ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
            //Left
            ctx.fillRect(0, 0, crop.x, this.canvas.height);
            //Top
            ctx.fillRect(crop.x, 0, crop.size, crop.y);
            //Right
            ctx.fillRect(crop.x + crop.size, 0, this.canvas.width - (crop.x + crop.size), this.canvas.height);
            //Bottom
            ctx.fillRect(crop.x, crop.y + crop.size, crop.size, this.canvas.height - (crop.y + crop.size));


            //Draw the lines
            ctx.strokeStyle = '#FFF';
            ctx.lineWidth = lineWidth;
            ctx.strokeRect(crop.x, crop.y, crop.size, crop.size);

            ctx.fillStyle = 'rgb(200, 200, 200)';
            //Top left
            ctx.fillRect(crop.x - halfHandleSize, crop.y - halfHandleSize, handleSize, handleSize);
            //Top right
            ctx.fillRect(crop.x - halfHandleSize + crop.size, crop.y - halfHandleSize, handleSize, handleSize);
            //Bottom left
            ctx.fillRect(crop.x - halfHandleSize, crop.y + crop.size - halfHandleSize, handleSize, handleSize);
            //Bottom right
            ctx.fillRect(crop.x - halfHandleSize + crop.size, crop.y + crop.size - halfHandleSize, handleSize, handleSize);
        }

        this.updatePreview();
    }
}

ImageCropper.ROTATE_CLOCKWISE = 1;
ImageCropper.ROTATE_COUNTERCLOCKWISE = -1;

ImageCropper.ACTION_RESIZE_CROP = 0;
ImageCropper.ACTION_MOVE_CROP = 1;

ImageCropper.ANCHOR_TOP_LEFT = 0;
ImageCropper.ANCHOR_TOP_RIGHT = 1;
ImageCropper.ANCHOR_BOTTOM_RIGHT = 2;
ImageCropper.ANCHOR_BOTTOM_LEFT = 3;

ImageCropper.ElEMENT_ANCHOR = 0;
ImageCropper.ElEMENT_CONTENT = 1;
ImageCropper.ElEMENT_BACKGROUND = 2;


export default ImageCropper;
